import {DeprecatedDataFrame} from 'data-frames/DataFrameTypes';

/**
 * @deprecated This function is implemented with an old version of the DataFrame interface. New uses are discouraged,
 * instead the function should be converted to use the new interface.
 */
// TODO(BNCH-24546): Remove or reimplement data frame utils that use DeprecatedDataFrame
export default function areColumnValuesUnique<TDataRow>(
  dataFrame: DeprecatedDataFrame<TDataRow>,
  columnToCheck: keyof TDataRow
): boolean {
  return new Set(dataFrame.points.map((row) => row[columnToCheck])).size === dataFrame.points.length;
}
